(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const announcementBar = document.getElementById('announcement-bar');
    const slider = document.getElementById('announcements-slider');
    const closeButton = document.getElementById('close-announcement');
    const announcements = document.querySelectorAll('.announcement-item');

    if (!announcementBar || !slider || announcements.length === 0) return;

    // Close button functionality
    if (closeButton) {
      closeButton.addEventListener('click', function() {
        announcementBar.style.display = 'none';
        sessionStorage.setItem('announcement-bar-hidden', 'true');
      });
    }
    
    // Auto-scroll functionality (only if more than one announcement)
    if (announcements.length > 1) {
      let currentIndex = 0;
      let intervalId;
      let isResetting = false;
      
      // Count only original announcements (not clones)
      const originalCount = Math.floor(announcements.length / 2);
      
      function slideToNext() {
        if (isResetting) return;
        
        const itemHeight = announcements[0].offsetHeight;
        currentIndex++;
        
        // Move slider down
        const translateY = -(currentIndex * itemHeight);
        slider.style.transform = `translateY(${translateY}px)`;
        
        // If we've scrolled past all original items, reset after showing the first clone
        if (currentIndex >= originalCount) {
          isResetting = true;
          
          // Wait for the transition to complete, then instantly reset
          setTimeout(() => {
            slider.style.transition = 'none';
            currentIndex = 0;
            slider.style.transform = `translateY(0px)`;
            
            // Re-enable transition and allow next slide
            setTimeout(() => {
              slider.style.transition = 'transform 0.5s ease-in-out';
              isResetting = false;
            }, 100);
          }, 500);
        }
      }
      
      function startAutoScroll() {
        intervalId = setInterval(slideToNext, 5000);
      }
      
      function stopAutoScroll() {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      }
      
      // Start auto-scrolling
      startAutoScroll();
      
      // Clean up interval when announcement is closed
      closeButton?.addEventListener('click', function() {
        stopAutoScroll();
      });
      
      // Pause on hover
      announcementBar.addEventListener('mouseenter', function() {
        stopAutoScroll();
      });

      // Resume on mouse leave
      announcementBar.addEventListener('mouseleave', function() {
        startAutoScroll();
      });

      // Pause on focus for keyboard users
      announcementBar.addEventListener('focusin', function() {
        stopAutoScroll();
      });

      announcementBar.addEventListener('focusout', function() {
        startAutoScroll();
      });

      // Clean up on page unload
      window.addEventListener('beforeunload', function() {
        stopAutoScroll();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function() {
  // Refresh cart page content via AJAX (for sync with cart drawer)
  async function refreshCartPage() {
    try {
      const timestamp = Date.now();
      const response = await fetch(`/?sections=cart&t=${timestamp}`);
      if (response.ok) {
        const data = await response.json();
        const html = data['cart'];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Replace the cart page section content
        const newContent = doc.querySelector('.cart-page');
        const currentContent = document.querySelector('.cart-page');
        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }
      }
    } catch (error) {
      console.error('Error refreshing cart page:', error);
    }
  }

  // Listen for cart updates from the drawer
  document.addEventListener('cart:updated', refreshCartPage);

  // Update cart item quantity on cart page
  window.updateCartPageQuantity = async (button, delta) => {
    const itemEl = button.closest('[data-cart-item]');
    const primaryKey = itemEl?.dataset.cartItem;

    if (!primaryKey) return;

    // Show loading state
    itemEl.classList.add('opacity-50', 'pointer-events-none');

    try {
      // Get current cart to find item quantity
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      const item = cart.items.find(i => i.key === primaryKey);
      if (item) {
        const newQuantity = Math.max(0, item.quantity + delta);

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: primaryKey, quantity: newQuantity })
        });

        // Reload page to show updated cart
        window.location.reload();
      }
    } catch (error) {
      console.error('Error updating cart:', error);
      itemEl.classList.remove('opacity-50', 'pointer-events-none');
    }
  };

  // Remove cart item on cart page
  window.removeCartPageItem = async (button) => {
    const itemEl = button.closest('[data-cart-item]');
    const allKeysStr = itemEl?.dataset.allKeys;

    if (!allKeysStr) return;

    // Show loading state
    itemEl.classList.add('opacity-50', 'pointer-events-none');

    try {
      const allKeys = allKeysStr.split(',').filter(k => k);
      const updates = {};
      allKeys.forEach(key => { updates[key] = 0; });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      // Reload page to show updated cart
      window.location.reload();
    } catch (error) {
      console.error('Error removing item:', error);
      itemEl.classList.remove('opacity-50', 'pointer-events-none');
    }
  };

  // Gift message toggle
  const giftToggle = document.getElementById('cart-gift-message-toggle');
  const giftContainer = document.getElementById('cart-gift-message-container');
  const giftInput = document.getElementById('cart-gift-message-input');
  const charCount = document.getElementById('cart-gift-char-count');

  if (giftToggle && giftContainer) {
    giftToggle.addEventListener('change', async function() {
      if (this.checked) {
        giftContainer.classList.remove('max-h-0', 'opacity-0');
        giftContainer.classList.add('max-h-40', 'opacity-100');
        if (giftInput) setTimeout(() => giftInput.focus(), 300);
      } else {
        giftContainer.classList.remove('max-h-40', 'opacity-100');
        giftContainer.classList.add('max-h-0', 'opacity-0');
        if (giftInput) {
          giftInput.value = '';
          if (charCount) charCount.textContent = '0';
          // Save empty message
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { gift_message: '' } })
          });
        }
      }
    });
  }

  // Gift message character counter and auto-save
  if (giftInput) {
    let debounceTimer;
    giftInput.addEventListener('input', function() {
      if (charCount) charCount.textContent = this.value.length;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(async () => {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { gift_message: giftInput.value } })
        });
      }, 500);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const footerNewsletter = {
    form: document.getElementById('footer-newsletter-form'),
    emailInput: document.getElementById('footer-newsletter-email'),
    submitBtn: document.getElementById('footer-newsletter-submit'),
    message: document.getElementById('footer-newsletter-message'),

    init() {
      if (!this.form) return;
      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    },

    async handleSubmit(e) {
      e.preventDefault();

      const email = this.emailInput?.value?.trim();
      if (!email) return;

      // Show loading state
      this.submitBtn.disabled = true;
      this.submitBtn.textContent = 'Sending...';
      this.message.classList.add('hidden');

      try {
        const formData = new FormData();
        formData.append('g', 'T2jEnc');
        formData.append('email', email);
        formData.append('$source', 'Footer Signup');

        const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          this.showSuccess();
        } else {
          throw new Error('Subscription failed');
        }
      } catch (error) {
        console.error('Error submitting to Klaviyo:', error);
        this.showSuccess();
      }
    },

    showSuccess() {
      this.emailInput.value = '';
      this.submitBtn.disabled = false;
      this.submitBtn.textContent = 'Subscribe';
      this.message.textContent = 'Thanks for subscribing!';
      this.message.classList.remove('hidden');
      this.message.classList.add('text-fresh-sage');

      setTimeout(() => {
        this.message.classList.add('hidden');
      }, 5000);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => footerNewsletter.init());
  } else {
    footerNewsletter.init();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile menu functionality
  const mobileMenu = {
    overlay: document.getElementById('mobile-menu-overlay'),
    panel: document.getElementById('mobile-menu-panel'),
    backdrop: document.getElementById('mobile-menu-backdrop'),
    openBtn: document.getElementById('mobile-menu-button'),
    closeBtn: document.getElementById('mobile-menu-close'),
    focusableElements: null,
    firstFocusable: null,
    lastFocusable: null,

    init() {
      if (!this.overlay) return;

      // Open button
      this.openBtn?.addEventListener('click', () => this.open());

      // Close button
      this.closeBtn?.addEventListener('click', () => this.close());

      // Backdrop click
      this.backdrop?.addEventListener('click', () => this.close());

      // Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });

      // Focus trap
      this.overlay.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && this.isOpen()) {
          this.handleTabKey(e);
        }
      });

      // Mobile dropdown toggles
      const dropdownToggles = this.overlay.querySelectorAll('.mobile-dropdown-toggle');
      dropdownToggles.forEach((toggle) => {
        toggle.addEventListener('click', function() {
          const isExpanded = this.getAttribute('aria-expanded') === 'true';
          const content = this.nextElementSibling;
          const icon = this.querySelector('svg');

          this.setAttribute('aria-expanded', !isExpanded);
          content.classList.toggle('hidden');
          icon.style.transform = content.classList.contains('hidden') ? 'rotate(0deg)' : 'rotate(180deg)';
        });
      });
    },

    open() {
      // Update button state
      this.openBtn?.setAttribute('aria-expanded', 'true');

      // Show overlay
      this.overlay.classList.remove('hidden');
      document.body.style.overflow = 'hidden';

      // Force reflow
      this.overlay.offsetWidth;

      // Animate in
      setTimeout(() => {
        this.backdrop.classList.remove('opacity-0');
        this.backdrop.classList.add('opacity-100');
        this.panel.classList.remove('-translate-x-full');
        this.panel.classList.add('translate-x-0');
      }, 10);

      // Set up focus trap
      this.setupFocusTrap();

      // Focus first element
      setTimeout(() => {
        this.closeBtn?.focus();
      }, 300);
    },

    close() {
      // Update button state
      this.openBtn?.setAttribute('aria-expanded', 'false');

      // Animate out
      this.backdrop.classList.remove('opacity-100');
      this.backdrop.classList.add('opacity-0');
      this.panel.classList.remove('translate-x-0');
      this.panel.classList.add('-translate-x-full');

      // Hide overlay after animation
      setTimeout(() => {
        this.overlay.classList.add('hidden');
        document.body.style.overflow = '';
      }, 320);

      // Return focus to open button
      this.openBtn?.focus();
    },

    isOpen() {
      return !this.overlay.classList.contains('hidden');
    },

    setupFocusTrap() {
      this.focusableElements = this.panel.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (this.focusableElements.length > 0) {
        this.firstFocusable = this.focusableElements[0];
        this.lastFocusable = this.focusableElements[this.focusableElements.length - 1];
      }
    },

    handleTabKey(e) {
      if (!this.firstFocusable || !this.lastFocusable) return;

      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === this.firstFocusable) {
          e.preventDefault();
          this.lastFocusable.focus();
        }
      } else {
        // Tab
        if (document.activeElement === this.lastFocusable) {
          e.preventDefault();
          this.firstFocusable.focus();
        }
      }
    }
  };

  // Mobile search toggle
  const mobileSearch = {
    toggle: document.getElementById('search-toggle'),
    container: document.getElementById('mobile-search'),

    init() {
      if (!this.toggle || !this.container) return;

      this.toggle.addEventListener('click', () => {
        this.container.classList.toggle('hidden');
        if (!this.container.classList.contains('hidden')) {
          this.container.querySelector('input')?.focus();
        }
      });
    }
  };

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    mobileMenu.init();
    mobileSearch.init();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function() {
  const container = document.getElementById('product-recommendations');
  if (!container) return;

  const url = container.dataset.url;
  if (!url) return;

  fetch(url)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const recommendations = doc.querySelector('.product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        container.replaceWith(recommendations);
      }
    })
    .catch(error => {
      console.error('Error loading product recommendations:', error);
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const productPage = {
    form: null,
    variants: [],
    currency: {},
    mainImage: null,
    thumbnails: [],

    init() {
      this.form = document.querySelector('.product-form');
      this.mainImage = document.getElementById('main-product-image');
      this.thumbnails = document.querySelectorAll('.thumbnail-btn');

      // Parse product data
      const variantsJson = document.getElementById('product-json');
      const currencyJson = document.getElementById('currency-json');
      if (variantsJson) this.variants = JSON.parse(variantsJson.textContent);
      if (currencyJson) this.currency = JSON.parse(currencyJson.textContent);

      this.bindEvents();
      this.initializeSelectedLabels();
    },

    bindEvents() {
      // Form submit - AJAX add to cart
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.handleAddToCart(e));
      }

      // Thumbnail click handlers
      this.thumbnails.forEach(btn => {
        btn.addEventListener('click', () => this.handleThumbnailClick(btn));
      });

      // Quantity buttons
      const decreaseBtn = document.getElementById('quantity-decrease');
      const increaseBtn = document.getElementById('quantity-increase');
      if (decreaseBtn) decreaseBtn.addEventListener('click', () => this.changeQuantity(-1));
      if (increaseBtn) increaseBtn.addEventListener('click', () => this.changeQuantity(1));

      // Variant selection
      document.querySelectorAll('.variant-input').forEach(input => {
        input.addEventListener('change', () => {
          this.updateVariantLabel(input);
          this.updateVariant();
        });
      });

    },

    async handleAddToCart(e) {
      e.preventDefault();

      const addToCartBtn = this.form.querySelector('button[type="submit"]');
      const btnText = addToCartBtn?.querySelector('span') || addToCartBtn;
      const originalText = btnText?.textContent;

      // Show loading state
      if (btnText) btnText.textContent = 'Adding...';
      if (addToCartBtn) addToCartBtn.disabled = true;

      try {
        const formData = new FormData(this.form);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        const item = await response.json();

        // Update cart count in header
        this.updateCartCount();

        // Open cart drawer with refreshed content
        if (typeof window.openCartDrawerWithRefresh === 'function') {
          window.openCartDrawerWithRefresh();
        } else if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        }

        // Brief success state
        if (btnText) btnText.textContent = 'Added!';
        setTimeout(() => {
          if (btnText) btnText.textContent = originalText;
          if (addToCartBtn) addToCartBtn.disabled = false;
        }, 1500);

      } catch (error) {
        console.error('Add to cart error:', error);
        if (btnText) btnText.textContent = 'Error - Try Again';
        setTimeout(() => {
          if (btnText) btnText.textContent = originalText;
          if (addToCartBtn) addToCartBtn.disabled = false;
        }, 2000);
      }
    },

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        // Update all cart count elements
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.classList.remove('hidden');
            el.classList.add('flex');
          } else {
            el.classList.add('hidden');
            el.classList.remove('flex');
          }
        });
      } catch (error) {
        console.error('Failed to update cart count:', error);
      }
    },

    handleThumbnailClick(btn) {
      const imageUrl = btn.dataset.imageUrl;
      const imageAlt = btn.dataset.imageAlt;

      if (this.mainImage && imageUrl) {
        this.mainImage.src = imageUrl;
        this.mainImage.alt = imageAlt || '';
      }

      // Update active thumbnail
      this.thumbnails.forEach(t => {
        t.classList.remove('border-clay-pot');
        t.classList.add('border-transparent');
      });
      btn.classList.remove('border-transparent');
      btn.classList.add('border-clay-pot');
    },

    changeQuantity(delta) {
      const quantityInput = document.getElementById('quantity');
      if (!quantityInput) return;

      const currentValue = parseInt(quantityInput.value) || 1;
      const newValue = Math.max(1, currentValue + delta);
      quantityInput.value = newValue;
    },

    updateVariantLabel(input) {
      const optionGroup = input.closest('.option-group');
      if (!optionGroup) return;

      // Remove selected class from all labels
      optionGroup.querySelectorAll('label').forEach(label => {
        label.classList.remove('border-earth-ash', 'text-deep-forest', 'bg-earth-ash');
        label.classList.add('border-earth-ash', 'text-olive-bark', 'bg-white');
      });

      // Add selected class to checked label
      const checkedLabel = optionGroup.querySelector('.variant-input:checked + label');
      if (checkedLabel) {
        checkedLabel.classList.remove('border-earth-ash', 'text-olive-bark', 'bg-white');
        checkedLabel.classList.add('border-earth-ash', 'text-deep-forest', 'bg-earth-ash');
      }
    },

    updateVariant() {
      const variantInputs = this.form?.querySelectorAll('.variant-input:checked');
      if (!variantInputs) return;

      const selectedOptions = Array.from(variantInputs).map(input => input.value);

      // Find matching variant
      const matchingVariant = this.variants.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });

      if (!matchingVariant) return;

      // Update hidden variant ID
      const idInput = this.form.querySelector('input[name="id"]');
      if (idInput) idInput.value = matchingVariant.id;

      // Update URL without reload
      const url = new URL(window.location);
      url.searchParams.set('variant', matchingVariant.id);
      window.history.replaceState({}, '', url);

      // Update price display
      this.updatePrice(matchingVariant);

      // Update SKU
      this.updateSku(matchingVariant);

      // Update add to cart button
      this.updateAddToCart(matchingVariant);

      // Update low stock indicator
      this.updateLowStock(matchingVariant);

      // Switch to variant-specific image
      this.switchToVariantImage(matchingVariant.id);
    },

    updateLowStock(variant) {
      const indicator = document.getElementById('low-stock-indicator');
      const container = indicator?.parentElement;

      // Get threshold from data attribute or default to 5
      const threshold = parseInt(document.querySelector('[data-low-stock-threshold]')?.dataset.lowStockThreshold) || 5;

      if (!container) return;

      // Check if variant has inventory tracking and is set to deny when out of stock
      const showIndicator = variant.inventory_management === 'shopify'
        && variant.inventory_policy === 'deny'
        && variant.inventory_quantity > 0
        && variant.inventory_quantity <= threshold;

      if (showIndicator) {
        if (!indicator) {
          // Create indicator if it doesn't exist
          const newIndicator = document.createElement('div');
          newIndicator.id = 'low-stock-indicator';
          newIndicator.className = 'mb-4 flex items-center gap-2 text-sm text-clay-pot';
          newIndicator.innerHTML = `
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
            <span class="low-stock-text">Only ${variant.inventory_quantity} left in stock</span>
          `;
          // Insert before purchase section
          const purchaseSection = document.querySelector('.purchase-section');
          if (purchaseSection) {
            purchaseSection.parentElement.insertBefore(newIndicator, purchaseSection);
          }
        } else {
          // Update existing indicator
          const textEl = indicator.querySelector('.low-stock-text') || indicator.lastChild;
          if (textEl.nodeType === Node.TEXT_NODE) {
            textEl.textContent = `Only ${variant.inventory_quantity} left in stock`;
          } else {
            textEl.textContent = `Only ${variant.inventory_quantity} left in stock`;
          }
          indicator.style.display = 'flex';
        }
      } else if (indicator) {
        indicator.style.display = 'none';
      }
    },

    updatePrice(variant) {
      const priceElement = document.querySelector('.current-price');
      const compareElement = document.querySelector('.compare-price');

      if (priceElement) {
        priceElement.textContent = this.formatMoney(variant.price);
      }

      if (compareElement) {
        if (variant.compare_at_price > variant.price) {
          compareElement.textContent = this.formatMoney(variant.compare_at_price);
          compareElement.style.display = 'inline';
        } else {
          compareElement.style.display = 'none';
        }
      }
    },

    updateSku(variant) {
      const skuElement = document.getElementById('product-sku');
      if (skuElement) {
        skuElement.textContent = variant.sku || '';
        skuElement.closest('.sku-display').style.display = variant.sku ? 'block' : 'none';
      }
    },

    updateAddToCart(variant) {
      const addToCartBtn = this.form?.querySelector('button[type="submit"]');

      if (addToCartBtn) {
        const btnText = addToCartBtn.querySelector('span') || addToCartBtn;
        if (variant.available) {
          btnText.textContent = 'Add to Cart';
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('opacity-50', 'cursor-not-allowed');
        } else {
          btnText.textContent = 'Sold Out';
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('opacity-50', 'cursor-not-allowed');
        }
      }
    },

    switchToVariantImage(variantId) {
      // Find thumbnail that matches this variant
      const matchingThumbnail = Array.from(this.thumbnails).find(btn => {
        const variantIds = btn.dataset.variantIds?.split(',') || [];
        return variantIds.includes(String(variantId));
      });

      if (matchingThumbnail) {
        this.handleThumbnailClick(matchingThumbnail);
      }
    },

    formatMoney(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: this.currency.code || 'USD'
      }).format(cents / 100);
    },

    initializeSelectedLabels() {
      document.querySelectorAll('.variant-input:checked').forEach(input => {
        const label = input.nextElementSibling;
        if (label) {
          label.classList.remove('border-earth-ash', 'text-olive-bark', 'bg-white');
          label.classList.add('border-earth-ash', 'text-deep-forest', 'bg-earth-ash');
        }
      });
    }
  };

  document.addEventListener('DOMContentLoaded', () => productPage.init());

  } catch(e) { console.error(e); }
})();
})();
